<div class="event-header">
  <h1>{{ eventStoreService.event()!.name }}</h1>
  @if (eventStoreService.isLocked()) {
    <div class="event-header__locked-badge">
      <mat-icon>lock</mat-icon>
      <span>Locked</span>
    </div>
  }
  <div class="event-header__spacer"></div>
  @if (!announcerMode.isActive()) {
    @if (
      eventStoreService.event()?.paymentType !== EventPaymentEnum.CARD_ONLY &&
      eventStoreService.isEventPaid()
    ) {
      <div class="event-header__item">
        <a matButton="filled" [routerLink]="['shoutouts', 'kiosk']">
          Kiosk POS&nbsp;<mat-icon
            aria-hidden="false"
            aria-label="Send Shoutout in Kiosk POS"
            matTooltip="Send Shoutout in Kiosk POS"
            fontIcon="send"
          ></mat-icon>
        </a>
      </div>
    }
    <div class="event-header__item">
      @if (!eventStoreService.isLocked()) {
        <a
          matIconButton
          color="secondary"
          [routerLink]="['edit']"
          matTooltip="Edit Event"
        >
          <mat-icon aria-hidden="false" aria-label="Edit Event" fontIcon="edit">
          </mat-icon>
        </a>
      } @else {
        <button
          matIconButton
          color="secondary"
          [disabled]="true"
          matTooltip="Event is locked and cannot be edited"
        >
          <mat-icon
            aria-hidden="false"
            aria-label="Edit Event (Disabled)"
            fontIcon="edit"
          >
          </mat-icon>
        </button>
      }
      <a matIconButton color="secondary" (click)="shareShoutoutCreateLink()">
        <mat-icon
          aria-hidden="false"
          aria-label="Share Purchase Link"
          matTooltip="Share Purchase Link"
          fontIcon="share"
        >
        </mat-icon>
      </a>
      <a matIconButton color="secondary" [routerLink]="['qr']" target="_blank">
        <mat-icon
          aria-hidden="false"
          aria-label="Print Purchase QR"
          matTooltip="Print Purchase QR"
          fontIcon="qr_code"
        >
        </mat-icon>
      </a>
      <a
        matIconButton
        color="secondary"
        [routerLink]="['wall']"
        target="_blank"
      >
        <mat-icon
          aria-hidden="false"
          aria-label="Display Shoutout Wall"
          matTooltip="Display Shoutout Wall"
          fontIcon="tv"
        >
        </mat-icon>
      </a>
      <a matIconButton color="secondary" (click)="viewBalance()">
        <mat-icon
          aria-hidden="false"
          aria-label="Shoutout Count"
          matTooltip="Shoutout Count"
          fontIcon="account_balance"
        >
        </mat-icon>
      </a>
    </div>
  }
  <div class="event-header__item">
    @if (auth.isOrganizer() && !announcerMode.isActive()) {
      <a matButton="elevated" color="warn" (click)="enterAnnouncerMode()">
        Enter Announcer Mode&nbsp;<mat-icon
          aria-hidden="false"
          aria-label="Enter Announcer Mode"
          matTooltip="Enter Announcer Mode"
          fontIcon="lock"
        ></mat-icon>
      </a>
    }
    <a
      matButton="elevated"
      [ngClass]="{ accent: shoutoutsToAnnounceCount() > 0 }"
      (click)="startAnnouncing()"
    >
      Start Announcing&nbsp;<mat-icon
        aria-hidden="false"
        aria-label="Start Announcing"
        matTooltip="Start Announcing"
        fontIcon="announcement"
      ></mat-icon>
    </a>
  </div>
</div>
